import PropTypes from 'prop-types';
export var optionShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
});
export var groupShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  property: PropTypes.string.isRequired,
  initial: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(optionShape).isRequired,
  renderButton: PropTypes.func
});
export var groupsArrayOf = PropTypes.arrayOf(groupShape);